export default function () {
    const $filterbar = $('.filterbar');
    const $date = $('.date-input');

    $filterbar.each((i, filterbar) => {
        $filterbar.find('.filter').on('click', (e) => {
            e.preventDefault();
            const $element = $(e.currentTarget);
            const $elementLink = $element.find('a');
            const href = $elementLink.attr('href');
            const $filterContent = $(filterbar).find('.filter-content');

            if ($element.hasClass('active')) {
                $element.removeClass('active');
                $filterContent.find('.filter-pane').removeClass('active');
            } else {
                $filterbar.find('.filter').removeClass('active');
                $filterbar.find('.filter-pane').removeClass('active');
                $element.addClass('active');
                $filterContent.find(href).addClass('active');
            }
        });
    });

    if ($date.length) {
        const script = '/typo3conf/ext/udg_package/Resources/Public/JavaScript/daterangepicker.min.js';
        $.getScript(script).done(() => {
            // daterangepicker
            $date.each((i, filter) => {
                const $filter = $(filter);
                const $dateField = $filter.find('.date');
                const $daterange = $('.daterange-inputwrapper');
                $dateField.daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: true,
                    autoUpdateInput: false,
                    autoApply: true,
                    locale: {
                        format: 'DD.MM.YYYY',
                        daysOfWeek: [
                            $daterange.data('daysofweeksu'),
                            $daterange.data('daysofweekmo'),
                            $daterange.data('daysofweektu'),
                            $daterange.data('daysofweekwe'),
                            $daterange.data('daysofweekth'),
                            $daterange.data('daysofweekfr'),
                            $daterange.data('daysofweeksa'),
                        ],
                        monthNames: [
                            $daterange.data('monthnamesjanuary'),
                            $daterange.data('monthnamesfebruary'),
                            $daterange.data('monthnamesmarch'),
                            $daterange.data('monthnamesapril'),
                            $daterange.data('monthnamesmay'),
                            $daterange.data('monthnamesjune'),
                            $daterange.data('monthnamesjuly'),
                            $daterange.data('monthnamesaugust'),
                            $daterange.data('monthnamesseptember'),
                            $daterange.data('monthnamesoctober'),
                            $daterange.data('monthnamesnovember'),
                            $daterange.data('monthnamesdecember'),
                        ],
                    },
                    parentEl: $filter,
                });

                $filter.find('.from-date').on('apply.daterangepicker', function fromDateHandler(ev, picker) {
                    $(this).val(picker.startDate.format('DD.MM.YYYY'));
                });

                $filter.find('.to-date').on('apply.daterangepicker', function toDateHandler(ev, picker) {
                    $(this).val(picker.endDate.format('DD.MM.YYYY'));
                });
            });
        });
    }
}
